import axios from 'axios';

// نسخة axios خاصّة ببوابة مدير النظام.
// السبب: الـ interceptor في shared/api.js يُحوّل أي 401 إلى صفحة دخول الشركة (/login)
// عبر window.location — وهذا يُخرج مدير النظام من بوابته عند كلمة مرور خاطئة أو انتهاء
// جلسة. هذه النسخة تُبقي معالجة 401 داخل البوابة (ولا نُعدّل shared/api.js).
export const platformApi = axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 20000
});

// مسارات نُعالج 401 فيها بأنفسنا داخل الشاشة (دخول / فحص الجلسة / تغيير كلمة المرور)
const SELF_HANDLED = ['/platform/login', '/platform/me', '/platform/change-password'];

let sessionExpiredHandler = null;

/** يُسجّل ما يحدث عند انتهاء الجلسة أثناء الاستخدام (يُستخدم من usePlatformAuth). */
export function setSessionExpiredHandler(fn) {
  sessionExpiredHandler = typeof fn === 'function' ? fn : null;
}

platformApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || '';
    if (status === 401 && !SELF_HANDLED.some((p) => url.includes(p))) {
      if (sessionExpiredHandler) sessionExpiredHandler();
    }
    return Promise.reject(err);
  }
);

/** رسالة خطأ عربية موحّدة لاستجابات البوابة. */
export function platformError(err, fallback = 'تعذّر إتمام العملية') {
  const status = err?.response?.status;
  if (status === 429) return 'محاولات كثيرة جداً — انتظر قليلاً ثم أعد المحاولة';
  return err?.response?.data?.error?.message || err?.message || fallback;
}

/** نسخ نص إلى الحافظة مع بديل للمتصفحات/السياقات غير الآمنة. */
export async function copyText(text) {
  const value = String(text ?? '');
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch { /* نُجرّب البديل */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
